export default __webpack_public_path__ + "static/media/lux_card.7466a27d.png";